import type { Blocker } from 'react-router-dom'
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
  Button,
} from '@fluentui/react-components'
import { Warning24Regular } from '@fluentui/react-icons'

interface Props {
  blocker: Blocker
}

/**
 * Dialog zobrazený pokud má formulář neuložené změny
 * a uživatel se pokouší navigovat pryč.
 */
export function UnsavedChangesDialog({ blocker }: Props) {
  const isBlocked = blocker.state === 'blocked'

  return (
    <Dialog open={isBlocked}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={null}
            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <Warning24Regular style={{ color: '#d97706' }} />
            Neuložené změny
          </DialogTitle>
          <DialogContent>
            Máte neuložené změny. Pokud odejdete, všechny změny budou ztraceny.
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => blocker.reset?.()}
            >
              Zůstat na stránce
            </Button>
            <Button
              appearance="secondary"
              onClick={() => blocker.proceed?.()}
            >
              Zahodit změny a odejít
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  )
}
